import React from 'react';
import { useHistory } from 'react-router-dom';
import { MESSAGE_SOURCE, SNAPSHOT_TEST } from 'utils/constants';
import { getConfig } from 'utils/config';
import getAuthClient from 'clients/auth';
import styles from './styles.module.scss';
import { emailRgx } from './utils';
import { IMessageData } from './types';
import { LoginForm } from './LoginForm';

const Simulator = () => {
  const history = useHistory();

  const handleSubmit = async (formData: any) => {
    try {
      const { identifier, password, patientId, program } = formData;
      const authClient = await getAuthClient();
      const baseLoginDTO = { password, clientId: 'pearPortal' };
      const loginDTO = emailRgx.test(identifier)
        ? { email: identifier, ...baseLoginDTO }
        : { username: identifier, ...baseLoginDTO };
      const { token: authToken } = await authClient
        .login({
          loginDTO,
        })
        .then((res) => res.data);
      const messageData: IMessageData = {
        authToken,
        patientId,
        source: MESSAGE_SOURCE,
        program,
      };
      const { APP_URL } = await getConfig();
      window.postMessage(messageData, APP_URL);
    } catch (error: any) {
      const { message } = error;
      console.log('===> ERROR: ', message); // eslint-disable-line
    }
  };

  const handleClose = () => {
    history.push(window.location.pathname);
  };

  /** Snapshot flags used to disable flakey components for Cypress snapshot test */
  return (
    <details open data-testid="login" className={styles.container}>
      <summary className={styles.title}>
        <span onClick={handleClose}> Close Simulator </span>
      </summary>
      <LoginForm handleSubmit={handleSubmit} />
      {SNAPSHOT_TEST && (
        <h2 className={styles.snapshotFlag}>
          {`The "SNAPSHOT_TEST" flag is ON: (some animation disabled)`}
        </h2>
      )}
    </details>
  );
};

export default Simulator;
